import { Directive, ElementRef, Inject, Input, OnChanges, PLATFORM_ID, Renderer2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLACEHOLDER_IMAGE_URL, getImageUrlCandidates } from '../utils/image.utils';

/**
 * Imposta `src` (img) o `background-image` (altri elementi) con il primo URL
 * raggiungibile tra i candidati Cloudinary; se nessuno carica usa il placeholder.
 */
@Directive({
  selector: '[appImageFallback]',
  standalone: true
})
export class ImageFallbackDirective implements OnChanges {
  @Input('appImageFallback') url: string | null | undefined;

  private requestId = 0;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnChanges(): void {
    const candidates = getImageUrlCandidates(this.url);
    if (!candidates.length) {
      this.apply(PLACEHOLDER_IMAGE_URL);
      return;
    }

    if (!isPlatformBrowser(this.platformId)) {
      this.apply(candidates[0]);
      return;
    }

    const id = ++this.requestId;
    this.pick(candidates, 0, id);
  }

  private pick(candidates: string[], index: number, id: number): void {
    if (index >= candidates.length) {
      this.apply(PLACEHOLDER_IMAGE_URL);
      return;
    }
    const img = new Image();
    img.onload = () => {
      if (id === this.requestId) {
        this.apply(candidates[index]);
      }
    };
    img.onerror = () => {
      if (id === this.requestId) {
        this.pick(candidates, index + 1, id);
      }
    };
    img.src = candidates[index];
  }

  private apply(url: string): void {
    const element = this.el.nativeElement;
    if (element.tagName === 'IMG') {
      this.renderer.setAttribute(element, 'src', url);
    } else {
      this.renderer.setStyle(element, 'backgroundImage', `url(${url})`);
    }
  }
}
